import Scene = Phaser.Scene;
import {lazyInject} from "@/container";
import {TYPES} from "@/types";
import {SceneService} from "@/services/scene-service";
import SceneUtils from "@/utils/scene-utils";
import {LoadUtils, LoaderState} from "@/utils/load-utils";
import {Keys} from "@/constants/key";
import BattleStore from "@/store/battle";
import {GameState} from "@/constants/game-state";
import {SceneName} from "@/model/scene-name";
import {Urls} from "@/constants/urls";
import PlayerUtils from "@/utils/player-utils";
import {Reloadable} from "@/scenes/reloadable";

export default class BattleLoadScene extends Scene implements Reloadable {

    @lazyInject(TYPES.SceneService)
    private sceneService!: SceneService;

    private canvas!: HTMLCanvasElement;

    private loaderState!: LoaderState;

    private progressShown: boolean = false;

    private proceeded: boolean = false;

    constructor() {
        super({ key: 'BattleLoadScene' });
    }

    public preload(): void {
        this.canvas = this.sys.game.canvas;
        SceneUtils.setCurrentScene(this);
    }

    public create(): void {
        let bs = BattleStore.getBattleStatus();
        if (!GameState.BATTLE_RESOURCES_LOADED) {
            if (!this.textures.exists(Keys.ATLAS_CREATURES_BATTLE_1)) {
                this.load.atlas(Keys.ATLAS_CREATURES_BATTLE_1, 'assets/creatures/creatures-battle-1-f.png', 'assets/creatures/creatures-battle-1-f.json');
            }
            this.load.image(Keys.IMG_LOSE_SKULL, 'assets/ui/lose_skull.png');
            GameState.BATTLE_RESOURCES_LOADED = true;
        }

        if (bs && bs.battle && bs.battle.specialMusicKey) {
            if (PlayerUtils.hasMarker('p5_completed') && bs.battle.specialMusicKey === 'battle') {
                this.load.audio(Keys.MUSIC_BATTLE_4, [`assets/sound/ogg/military.ogg`, `assets/sound/mp3/military.mp3`]);
            } else if (PlayerUtils.hasMarker('p5_in_progress') && bs.battle.specialMusicKey === 'battle') {
                this.load.audio(Keys.MUSIC_BATTLE_3, [`assets/sound/ogg/battle_3.ogg`, `assets/sound/mp3/battle_3.mp3`]);
            } else {
                this.load.audio(bs.battle.specialMusicKey, [`assets/sound/ogg/${bs.battle.specialMusicKey}.ogg`, `assets/sound/mp3/${bs.battle.specialMusicKey}.mp3`]);
            }
        } else {
            this.load.audio(Keys.MUSIC_BATTLE, [`assets/sound/ogg/battle.ogg`, `assets/sound/mp3/battle.mp3`]);
        }

        if (bs && bs.battle && bs.battle.backgroundKey) {
            if (Urls.IMAGES_WEBP.has(bs.battle.backgroundKey)) {
                this.load.image(bs.battle.backgroundKey, `assets/bg/${bs.battle.backgroundKey}.webp`);
            } else {
                this.load.image(bs.battle.backgroundKey, `assets/bg/${bs.battle.backgroundKey}.jpg`);
            }
        }
        this.load.start();
        this.showProgress()
    }

    private showProgress() {
        this.proceeded = false;
        if (!this.progressShown){
            this.loaderState = new LoaderState();
            // LoadUtils.drawClouds(this, this.canvas);
            LoadUtils.drawLoadingScreen(this);
            LoadUtils.showSimpleLoadingScreen(this, this.canvas, this.loaderState);
        } else if(this.load.isReady()) {
            this.proceedToScreen();
            return;
        }

        this.load.once(Phaser.Loader.Events.COMPLETE, () => {
            this.proceedToScreen();
        });
    }

    private proceedToScreen(){
        if (!this.proceeded) {
            BattleStore.getBattle().then(() => {
                this.scene.start(SceneService.getSceneKey(SceneName.BATTLE_SCENE), undefined);
                GameState.CLOUDS_SHOWN_FOR_SCREEN.set("battleScene", true);
                this.progressShown = true;
            });
            this.proceeded = true;
        } else {
            console.log('Proceeded again, haha!');
        }
    }

    update(time: number, delta: number){
        if(this.loaderState){
            this.loaderState.update(time, delta);
        }
    }

    public reload(): void {
        this.sceneService.startSceneInstant(this, SceneName.BATTLE_LOAD_SCENE);
    }
}
